/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetOrder200ResponseData } from './GetOrder200ResponseData'
import {
  GetOrder200ResponseDataFromJSON,
  GetOrder200ResponseDataFromJSONTyped,
  GetOrder200ResponseDataToJSON,
} from './GetOrder200ResponseData'

/**
 *
 * @export
 * @interface GetOrder200Response
 */
export interface GetOrder200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetOrder200Response
   */
  status: boolean
  /**
   *
   * @type {GetOrder200ResponseData}
   * @memberof GetOrder200Response
   */
  data: GetOrder200ResponseData
}

/**
 * Check if a given object implements the GetOrder200Response interface.
 */
export function instanceOfGetOrder200Response(
  value: object
): value is GetOrder200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetOrder200ResponseFromJSON(json: any): GetOrder200Response {
  return GetOrder200ResponseFromJSONTyped(json, false)
}

export function GetOrder200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOrder200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetOrder200ResponseDataFromJSON(json['data']),
  }
}

export function GetOrder200ResponseToJSON(
  value?: GetOrder200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetOrder200ResponseDataToJSON(value['data']),
  }
}
